<template>
    
                <div class="news-items mt54">

                    <a href="https://mp.weixin.qq.com/s/UwJegkTCQopR7H5eagBmSw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250913/001.jpg" alt="《盛会启幕！2025首届澳门中葡农业国际博览会：葡澳之窗，数见优农》" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/13<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">《盛会启幕！2025首届澳门中葡农业国际博览会：葡澳之窗，数见优农》</div>
                                <div class="desc">本次博览会以“绿色农业·共享机遇·共谋发展”为主题，“绿色导向”倡导农业绿色转型,展相关成果,呼应全球农业 “含绿量”提升趋势;“合作共赢”借澳门中葡平台,促中葡农业多领域深度交流,实现资源互补,“全球责任”以多元形式强化中葡农业品牌影响力,助力构建高效包容的全球粮食体系。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/vB3ieu_vPkBDC437MysLNw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250910/001.jpg" alt="第五届数字贸易创新应用峰会在澳门揭幕" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/10<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">第五届数字贸易创新应用峰会在澳门揭幕</div>
                                <div class="desc">由澳门质量品牌国际认证联盟与融贯云洲（珠海横琴）数字科技有限公司共同主办，“第五届数字贸易创新应用峰会”9月9日下午3时假澳门旅游塔宴会厅举行。本届峰会以“数促擎新质·云链贸全球”为主题，聚焦资料要素市场化与全球供应链数字化两大核心命题，旨在为政产学研等方面，搭建思想碰撞与务实合作的平台。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/b4Er5xPYXDg4gbdbzDq15A" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250905/001.jpg" alt="融贯正菱助澳人内地信用互认" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/05<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">融贯正菱助澳人内地信用互认</div>
                                <div class="desc">由珠海市发展和改革局、融贯国际、珠海市跨境信用协会、正菱链通数科、中国工商银行、中国民生银行主办的「融贯湾区 信筑未来」跨境信用评价助力澳门在内地便携化融资持信用评价报告澳门居民批量授信活动，昨日在融贯云洲举行，透过两地互认信用评价，便利澳门居民在内地进行各类金融活动。首批参与的两家金融机构携各项优惠，并设专员指导办理信用卡，活动吸引约20人参与。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/G7qj0AOXusi0QI_Dxwv19g" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250808/001.jpg" alt="共拓大健康出海新篇！广东省大健康产业协会考察团到访，澳门融贯获授牌成重要纽带" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">08/08<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">共拓大健康出海新篇！广东省大健康产业协会考察团到访，澳门融贯获授牌成重要纽带</div>
                                <div class="desc">2025年8月6日，由广东省大健康产业协会、广东省现代健康产业研究院主办，澳门融贯投资科技有限公司承办的 “大健康中国行” 大湾区（横琴 + 澳门站）活动圆满落幕。此次活动中，广东省现代健康产业研究院张咏院长带领 28 家协会会员企业家组成的考察团，深入横琴、澳门两地核心产业平台，聚焦大健康产业国际化出海发展，为琴澳大健康产业联动注入新活力。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/iscdYkSwkVGviWHZxJW0Fg" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250715/001.jpg" alt="中国农业展览协会地标精品粤港澳大湾区服务中心在南沙正式揭牌" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">07/15<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">中国农业展览协会地标精品粤港澳大湾区服务中心在南沙正式揭牌</div>
                                <div class="desc">2025年7月15日，在全国政协副主席、南沙澳促会顾问何厚铧，中国农业展览协会会长何斌等贵宾见证下，在澳门、南沙及葡语国家政界、商界、学界约一百五十位代表共同参与下，中国农业展览协会地标精品专业委员会粤港澳大湾区服务中心在广州南沙自贸区正式揭牌成立。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/zMM3WBp_i-MaI-RuGVVkxw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250712/001.png" alt="数字赋能澳门新发展：从信任基建到湾区融合—澳门系统性重塑与粤港澳大湾区协同发展新路径" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">07/12<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">数字赋能澳门新发展：从信任基建到湾区融合—澳门系统性重塑与粤港澳大湾区协同发展新路径</div>
                                <div class="desc">融贯已获批工业互联网标识解析综合型二级节点（横琴融贯），实现产品全生命周期数据上链存证，确保质量可追溯、认证可信赖。未来，融贯将进一步深化与横琴粤澳深度合作区的协同，探索跨境数据流动与数字贸易新机制。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/j9YwQntQWcrEhEp1P5f8sA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250702/001.jpg" alt="融贯国际参与港澳信用评价体系赋能大湾区产业与民生融合项目" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">07/02<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际参与港澳信用评价体系赋能大湾区产业与民生融合项目</div>
                                <div class="desc">“融聚新质 智创未来”——2025年珠海市重点项目投融资对接大会今日上午在珠海度假村举行，会上发布今年珠海面向民间资本推介项目清单、科技成果转化项目融资需求清单，以及珠海市银行业十大融资案例，并签署一批投融资或重点项目合作协议。</div>
                            </div>
                        </div>
                    </a>

                    <a href="https://mp.weixin.qq.com/s/M6BWmpFifW9GPS_HzHs6CA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250630/001.jpg" alt="“车轮上的中国梦”探澳门战略机遇" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/30<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">“车轮上的中国梦”探澳门战略机遇</div>
                                <div class="desc">「当年那抹红色车身掠过长安街时，车窗外是同胞们充满渴望的眼神——他们看到的不只是一台车，而是一个民族追赶世界的决心！」由PCRC超跑俱乐部、澳门中葡商贸促进协会、澳门智慧人文励政会联合主办的「晓说莲华：车轮上的中国梦」系列活动，6月30日在澳门科学馆会议中心隆重举行。中国改革开放先锋人物李晓华、体育局局长张子轩、澳门智慧人文励政会会长吴在权、澳门中葡商贸促进协会会长冯文滔等嘉宾出席，与本澳青年企业家共同探讨中国新能源汽车崛起背景下，澳门发挥「国家所需‧澳门所长」的战略优势。</div>
                            </div>
                        </div>
                    </a>

                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>